/**
 * Parses the access token.
 *
 * @param accessToken The access token (JSON Web Token).
 */
export function parseAccessToken(accessToken) {
    const base64Url = accessToken.split('.')[1];
    if (!base64Url) {
        throw Error('Invalid token');
    }
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    try {
        return JSON.parse(Buffer.from(base64, 'base64').toString());
    }
    catch (error) {
        throw Error(`Failed to parse the JSON Web Token with the following error: ${error}`);
    }
}
//# sourceMappingURL=jwt.js.map